import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPerson16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconPerson16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.75 5.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m.046 2.082a2.75 2.75 0 1 0-3.593 0A5 5 0 0 0 3 12v2h10v-2a5 5 0 0 0-3.204-4.668M8 8a4 4 0 0 0-4 4v1h8v-1a4 4 0 0 0-4-4"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPerson16);
